<template>
  <v-container class="outer_position">
    <v-layout class="inner_position">
      <v-flex>
        <v-row class="text-center">
          <v-col cols="12">
            <v-img
              :src="require('../assets/nullCart.png')"
              class="mb-3"
              contain
              height="200"
            />
          </v-col>
        </v-row>
        <div class="text-center">
          <p>{{$t('NoProduct_text1')}}</p>
          <v-btn outlined to="/">{{$t('NoProduct_button1')}}</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'NoProduct',

    data: () => ({
    }),
    methods: {
    },
  }
</script>

<style scoped>
.outer_position {
  position: fixed;
  width: 100%;
  top: 0px;
  margin: 0px;
  min-height: 200px;
  height: 100%;
}
.inner_position {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
